import { render } from "./KSDeleteGroupReport.vue?vue&type=template&id=973ada8e"
import script from "./KSDeleteGroupReport.vue?vue&type=script&lang=js"
export * from "./KSDeleteGroupReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__